import { FunctionComponent, ReactNode } from 'react'
import React from 'react'
import Popover from '@/components/UiElements/PopOver'
import languageList from '@/components/FontManager/mapData/languageList'
import Alert from '@/components/UiElements/Alert'
import {v4 as uuidv4} from 'uuid'

const Label = ({title, value, enable = true, className}: { title: string | ReactNode; value: string | ReactNode; enable?: boolean; className?: string | null }) => {
	return (
		<div className={`py-sm px-md h-[50px] rounded-md transition-all ${enable ? "bg-gray-100 group-hover:bg-gray-200 " : "bg-gray-50 group-hover:bg-gray-100"} ${enable ? "text-gray-900 group-hover:text-gray-900" : "text-gray-400 group-hover:text-gray-900"} ${className || ""}`}>
			<p className={"text-gray-400 text-xs"}>{title}</p>
			<p className={` text-sm  capitalize `}>{value}</p>
		</div>
	)
}


type FontListItemProps = {
	font: any
	className?: string
	onDelete?: (id: string) => void
	callBack: (item:any) => void
	move: (id:string, direction: 'up' | 'down') => void
}

const FontListItem: FunctionComponent<FontListItemProps> = ({ font, className = '', onDelete, callBack, move }) => {

	const handleDeleteItem = () => {
		Alert.showAlert({
			title: "Remove Font",
			message: (
				<div className={"flex flex-col items-center justify-center "}>
					<div className={"border border-gray-300 p-xl rounded-md my-md !text-[54px] capitalize"}>
						<img src={font.preview} className={"h-[64px]"} alt={font.name}/>
					</div>
					Are you sure you want to remove this font?
				</div>
			),

			isCancelable: true,
			button: "Confirm & Remove",
			danger: true,
			callBack: async (ok) => {
				if (ok) {
					onDelete?.(font.id)
				}
			},
		});
	}


	return (
		<div
			onClick={() => {
				callBack(font)
			}}
			id={font.id}
			className={`relative group active:bg-gray-100 flex py-sm  border-b-gray-200 border-b-[1px] items-center hover:bg-gray-50 cursor-pointer transition-all group gap-xl px-md h-[120px] ${className} ` }
		>


			<Popover
				toggle={(open) => (
					<div
						className={` select-none w-[37px] h-[37px] min-w-[37px] ${open ? "text-white bg-gray-900" : " bg-gray-200 hover:bg-gray-700 text-gray-900 hover:text-white"}     rounded-full flex-col justify-center items-center inline-flex font-icon-regular cursor-pointer transition-all`}


					>
						<div className="text-center ">ellipsis</div>
					</div>
				)}
				placement="bottom left"
				offsetX={0}
				offsetY={10}
				menu={[

					{
						title: <span className="capitalize">Move Up</span>,
						icon: 'arrow-up',
						onClick: ()=> move(font.id, 'up')

					},
					{
						title: <span className="capitalize">Move Down</span>,
						icon: 'arrow-down',
						onClick: ()=> move(font.id, 'down')

					},
					{ separator: true, className: 'my-[10px]' },
					{
						title: <span className="capitalize">Edit Font</span>,
						icon: '',
						onClick: ()=> callBack(font)

					},
					{
						title: <span className="capitalize">Duplicate </span>,
						icon: '',
						onClick: ()=> callBack({
							...font,
							id: uuidv4(),
							duplicatedFrom: font,
						})

					},
					{ separator: true, className: 'my-[10px]' },
					{
						title: <span className="capitalize">Delete</span>,
						icon: '',
						className: 'hover:bg-red-100 text-red-500',
						onClick:handleDeleteItem
					}
					,]}
			/>
			<div className={' flex flex-col justify-between f-full gap-md items-start transition-all h-[90px] w-full mix-blend-multiply'}>


				<div className={`text-title-md pl-md transition-all capitalize `}>
					<img src={font.preview} className={"h-[24px]"}/>
				</div>


				<div className={'flex flex-row gap-sm justify-between w-full '}>

					<div className={'flex flex-row gap-sm'}>
						<Label
							title="Status"
							value={font.active ? 'Active' : 'Inactive'}
							className={`w-[170px] capitalize`}
						/>
						<Label
							title="Language"
							value={languageList.find((lang)=> lang.value === (font.language || ""))?.label || font.language}
							className={`w-[170px] capitalize`}
						/>
						<Label
							title="Styles"
							value={font.fontStyle?.map((style:any)=> style.name).join(', ')}
							className={`capitalize`}
						/>
					</div>
				</div>
			</div>

		</div>
	);
}


export default FontListItem;